import useResponsiveBreakpoints from './useResponsiveBreakpoints';

const useResponsiveFontSize = () => {
  const { isXs, isSm, isMd, isLg, isXl, isXxl } = useResponsiveBreakpoints();

  if (isXs) return 12;
  if (isSm) return 13;
  if (isMd) return 14;
  if (isLg) return 15;
  if (isXl) return 16;
  if (isXxl) return 17;
  return 14; // Default fallback
};

export default useResponsiveFontSize;